/* eslint-disable no-return-await */
import moment from 'moment'
import Util from '@/assets/libs/util'
import requesModule from '@/assets/libs/requestModule'
import LocaleController from '@/assets/controllers/LocaleController'
import MainTef from '@/assets/tef/MainTef'
import CartController from '@/assets/controllers/CartController'
import SaleController from '@/assets/controllers/SaleController'
import PrinterController from '@/assets/controllers/PrinterController'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
import TefMessageController from '@/assets/controllers/TefMessageController'
import PaymentTimeoutController from '@/assets/controllers/PaymentTimeoutController'
import eventModule from '@/assets/libs/eventModule'
import TefErrors from '../tef/TefErrors'

const EVENT_CONFIGURE_TEF = '/configure'
const EVENT_START_TRANSACTION_TEF = '/start-transaction'
const EVENT_FINISH_TRANSACTION_TEF = '/finish-transaction'

// Restrições do TAA para TEF - Cartão DEBITO
const additionalParamsDebit = '[10;17;18;19;24;27;28;29;31;32;33;40;41]' // 16
// Restrições do TAA para TEF - Cartão CREDITO
const additionalParamsCredit = '[10;24;27;28;29;31;32;33;36;40;41;44]'

const PINPAD_ERROR_MESSAGE = LocaleController.getString('nao_foi_possivel_configurar_pinpad')
// const DENIED_BY_AUTH = LocaleController.getString('operacao_negada_pelo_autorizador')
// const PINPAD_ROUTINES_PROBLEM = LocaleController.getString('problema_execucao_rotinas_pinpad')
const TEF_PROBLEM = LocaleController.getString('problema_nao_identificado_TEF')
const CONCOMITANT_TEF_ERROR_MESSAGE = 'A aplicação tentou iniciar uma transação TEF com outra já em andamento - Trava ativada'

let paymentMethods = []
paymentMethods = Util.getLocalConfigs('metodosPagamento')

// Armazena o numero do comprovante de pagamento, que será passado para a Odhen Interface salvar a comanda paga
let paymentNumber = ''
let authHash = ''
let comprovanteTef = ''

let dataTransire = {
    paymentSelectedMethod: null,
    consumerCpf: '',
    router: null,
    date: null,
    hour: null
}

let dataCancelTransactionTransire = {
    nfceCode: null,
    nsu: null,
    entityIdentifier: null
}

let cancelTefData = {
    nsu: null,
    date: null,
    value: null,
    proof: null
}

let digitalWalletSelected = ''

let rechargeMode = false

let funcoesAdministrativasSelected = ''

let waitingForData = false

let collectDataModalData = null

const setFuncoesAdministrativasSelected = (selected) => {
    funcoesAdministrativasSelected = selected
}

const getFuncoesAdministrativasSelected = () => {
    return funcoesAdministrativasSelected
}

const startRechargeMode = function () {
    rechargeMode = true
}

const stopRechargeMode = function () {
    rechargeMode = false
}

const isInRechargeMode = function () {
    return rechargeMode
}

let isTefInProgress = false

const setIsTefInProgress = (isInProgress) => {
    isTefInProgress = isInProgress
}

const getIsTefInProgress = () => {
    return isTefInProgress
}

let autoCancelTefTriggered = false

const setAutoCancelTefTriggered = (isTriggered) => {
    autoCancelTefTriggered = isTriggered
    const MESSAGE = 'Flag autoCancelTefTriggered setada para: ' + autoCancelTefTriggered
    Util.logComunication('Trava TEF ', {}, MESSAGE)
}

const getAutoCancelTefTriggered = () => {
    return autoCancelTefTriggered
}

const setWaitingForData = (isWaiting) => {
    waitingForData = isWaiting
}

const getWaitingForData = () => {
    return waitingForData
}

// Traduz o valor de IDTIPORECE, no formato armazenado no DB da Teknisa, nos valores
// esperados pela DLL do TEF
const generateTefFunctionCode = (IDTIPORECE) => {
    if (IDTIPORECE === '1') {
        return 3
    } else if (IDTIPORECE === 'H') {
        return 122
    } else {
        return 2
    }
}

/**
 * @param endSitef: DSENDIPSITEF da tabela CAIXA
 * @param storeId: CDLOJATEF da tabela CAIXA
 * @param terminalId: CDTERTEF da tabela CAIXA
 * @param tefCommunic: CDTPCOMUNTLS Tabela caixa
 * @param tefEndProxy: CDENPROXYTLS Tabela caixa
 * @param tefProxyType: CDTPPROXYTLS Tabela caixa
 * @param tefToken: CDTOKENTLS Tabela caixa
 */
const configureTEF = async (endSitef, storeId, terminalId, CNPJLoja = null, CNPJTefHouse = null) => {
    let dataToSend = {
        endSitef: endSitef,
        storeId: storeId,
        terminalId: terminalId
    }
    const TLSCONFIG = Util.getTLSTefConfig()
    if (CNPJLoja) dataToSend.CNPJLoja = CNPJLoja
    if (CNPJTefHouse) dataToSend.CNPJTefHouse = CNPJTefHouse
    if (TLSCONFIG) dataToSend = {...dataToSend, ...TLSCONFIG}
    return await requesModule.curlRequest(
        EVENT_CONFIGURE_TEF,
        dataToSend
    ).then(r => {
        if (r && r.data && !r.error) {
            return r.data
        } else if (r.error) {
            return {
                error: true,
                errorType: r.message
            }
        }
    })
}

/**
 * @param startFunction: se é venda a credito, a debito, cancelamento de venda, etc
 * @param value: valor
 * @param text: numero do cupom referente à venda. Nesse momento o TAA ainda nao tem esse numero
 * @param date: data no formato YYYYMMDD
 * @param time: hora no formato HHmmssSS
 * @param operator: operador
 * @param additionalParams: o que deve ser bloqueado na maquininha
 */
const startTransactionTEF = async (startFunction, value, text, date, time, operator, additionalParams, isCancelTefOperation = false) => {
    if (isCancelTefOperation) {
        setFlagStatusTef(null)
    } else {
        setFlagStatusTef({
            startFunction: startFunction,
            value: value,
            text: text,
            date: date,
            time: time,
            operator: operator,
            additionalParams: additionalParams
        })
    }
    if (Util.isAndroidMode()) {
        const qrCodePinpad = Util.exibQrCodePinPad()
        let androidParams = JSON.stringify({ startFunction, value, text, date, time, operator, additionalParams, qrCodePinpad })
        let resStart = window.Android.startTransaction(androidParams)
        Util.logComunication('Android Start TEF', androidParams, resStart)
        resStart = JSON.parse(resStart)
        TefMessageController.setLastMessage(resStart.message)

        return resStart
    } else {
        let params = {
            startFunction: startFunction,
            value: value,
            text: text,
            date: date,
            time: time,
            operator: operator,
            additionalParams: additionalParams
        }
        return await requesModule.curlRequest(EVENT_START_TRANSACTION_TEF, params)
            .then(r => {
                Util.logComunication('Web Start TEF', params, r.data)
                return r.data
            })
    }
}

/**
 * @param confirm: indica se a transação deve ser confirmada (1) ou estornada (0)
 * @param text: número do Cupom Fiscal correspondente à venda
 * @param date: Data Fiscal no formato AAAAMMDD (a mesma passada quando iniciou a transacao)
 * @param time: Horário Fiscal no formato HHMMSS (a mesma passada quando iniciou a transacao)
 */
const finishTransactionTEF = async (confirm, text, date, time, totalValue = '') => {
    try {
        if (Util.isAndroidMode()) {
            let logMessage1 = `Chamada de finishTransactionTEF no Android com confirm = ${confirm}`
            Util.logComunication('Android Finish TEF ', {}, logMessage1)
            let additionalParams = ''
            let resFinish = window.Android.finishTransaction(confirm, text, date, time, additionalParams)
            Util.logComunication('Android Finish TEF', JSON.stringify({ confirm, text, date, time, additionalParams }), resFinish)
            resFinish = JSON.parse(resFinish)

            if (!resFinish.error && resFinish.result === 10000 && resFinish.message != null) {
                let messageType = resFinish.message.type
                let messageResultCode = resFinish.message.resultCode
                if (messageType === 'onData') {
                    let resContinua = await MainTef.continuaTransacaoTef(totalValue, null, null, null, null, null, null, false, null)
                    setIsTefInProgress(false)

                    if (!resContinua.error && resContinua.finishedTransaction) {
                        let logMessage2 = 'finishTransactionTEF no Android concluído com sucesso - passou pelo onData'
                        Util.logComunication('Android Finish TEF ', {}, logMessage2)
                        setFlagStatusTef(null)
                        return true
                    } else {
                        let logMessage = 'Ocorreu um resultado inesperado na chamada de continuaTransacaoTef a partir de finishTransactionTEF no Android'
                        Util.logComunication('Android Finish TEF ', {}, logMessage)
                        Util.logComunication('Android Finish TEF ', {}, resContinua)
                        return false
                    }
                } else if (messageType === 'onTransactionResult' && messageResultCode === 0) {
                    setIsTefInProgress(false)
                    setFlagStatusTef(null)
                    let logMessage2 = 'finishTransactionTEF no Android concluído com sucesso - não passou pelo onData'
                    Util.logComunication('Android Finish TEF ', {}, logMessage2)
                    return true
                } else {
                    // A documentação afirma que essa rotina no Android deveria ser iterativa, mas em nenhuma situação
                    // foi retornado um 'onData' no lugar de 'onTransactionResult', fazendo com que na prática ela retorne
                    // imediatamente todos os dados
                    let logMessage3 = 'Ocorreu um retorno de formato inesperado em finishTransactionTEF no Android'
                    Util.logComunication('Android Finish TEF ', {}, logMessage3)
                    Util.logComunication('Android Finish TEF ', {}, resFinish)
                    setIsTefInProgress(false)
                    return false
                }
            } else if (!resFinish.error && resFinish.result === 0) {
                setIsTefInProgress(false)
                setFlagStatusTef(null)
                let logMessage2 = 'finishTransactionTEF no Android concluído com sucesso - não passou pelo onData'
                Util.logComunication('Android Finish TEF ', {}, logMessage2)
                Util.logComunication('Android Finish TEF ', {}, resFinish)
                return true
            } else {
                let logMessage4 = 'Houve uma falha na execução de finishTransactionTEF no Android. O pagamento / estorno não foi concluído'
                Util.showInfoModal(logMessage4, true)
                Util.logComunication('Android Finish TEF ', {}, logMessage4)
                Util.logComunication('Android Finish TEF ', {}, resFinish)
                setIsTefInProgress(false)
                return false
            }
        } else {
            let params = {
                confirm: confirm,
                text: text,
                date: date,
                time: time
            }
            return await requesModule.curlRequest(EVENT_FINISH_TRANSACTION_TEF, params)
                .then(r => {
                    Util.logComunication('Web Finish TEF', params, r.data)
                    return r.data && r.data.error === false
                }).finally(() => {
                    setIsTefInProgress(false)
                })
        }
    } catch (error) {
        Util.logComunication('Exception ', {}, error.message)
    }
}

const proceedToConfigureTef = async () => {
    if (!isTefInProgress) {
        setIsTefInProgress(true)

        let endSitef = Util.getLocalConfigs('enderecoIPTEF')
        let storeId = Util.getLocalConfigs('codLojaTEF')
        let terminalId = Util.getLocalConfigs('codigoTerminalTEF')
        let CNPJLoja = Util.getLocalConfigs('storeCNPJ')
        let CNPJTefHouse = Util.getLocalConfigs('tefCnpjHouse') || '26269316000177'
        const CDTOKENTLS = Util.getLocalConfigs('tefToken') || ''
        const CDTPPROXYTLS = Util.getLocalConfigs('tefProxyType') || ''
        const CDTPCOMUNTLS = Util.getLocalConfigs('tefCommunic') || ''
        const CDENPROXYTLS = Util.getLocalConfigs('tefEndProxy') || ''

        let resConfig

        if (Util.isAndroidMode()) {
            let overridedSitefAddress = Util.getLocalConfigs('sitefAddress')
            if (overridedSitefAddress !== '' && overridedSitefAddress != null) {
                endSitef = overridedSitefAddress
            }

            let androidParams = JSON.stringify({endSitef, storeId, terminalId, CNPJLoja, CNPJTefHouse, CDTOKENTLS, CDTPCOMUNTLS, CDTPPROXYTLS, CDENPROXYTLS})
            resConfig = window.Android.configure(androidParams)
            Util.logComunication('Android Configure TEF', androidParams, resConfig)

            resConfig = JSON.parse(resConfig)
        } else {
            if (CNPJLoja) {
                resConfig = await configureTEF(endSitef, storeId, terminalId, CNPJLoja, CNPJTefHouse)
            } else {
                resConfig = await configureTEF(endSitef, storeId, terminalId)
            }
            Util.logComunication('Web Configure TEF', { endSitef, storeId, terminalId, CNPJLoja, CNPJTefHouse }, resConfig)
        }
        if (resConfig.error) {
            resConfig.errorType = resConfig.result || resConfig.errorType
            Util.logComunication('Android Configure TEF Exception ', {}, resConfig)
            setFlagStatusTef(null)
        }
        return resConfig
    } else {
        Util.logComunication('Exception ', {}, 'Tentativa de iniciar outra transação TEF com uma transação já em andamento')
        return handleTefInProgressError()
    }
}

const buildAdditionalParams = (tefFunctionCode) => {
    let additionalParams = ''

    if (tefFunctionCode === 2) { // Venda débito (cartões refeição, alimentação, etc. também entram nesse caso)
        additionalParams = additionalParamsDebit
    } else if (tefFunctionCode === 3) { // Venda crédito
        additionalParams = additionalParamsCredit
    } else if ((tefFunctionCode === 122)) { // Carteiras Digitais
        additionalParams = Util.exibQrCodePinPad() ? '{DevolveStringQRCode=0}' : '{DevolveStringQRCode=1}'
    }

    return additionalParams
}

const handleTefError = (resConfig) => {
    Util.logComunication('Exception ', {}, PINPAD_ERROR_MESSAGE)
    setFlagStatusTef(null)
    CartController.clearbandeiraCartao()
    CartController.clearDigitalWalletName()
    authHash = ''
    return {
        error: true,
        errorType: resConfig.errorType || 'pinpad config error'
    }
}

const handleTefInProgressError = () => {
    Util.logComunication('Exception ', {}, CONCOMITANT_TEF_ERROR_MESSAGE)
    setAutoCancelTefTriggered(true)
    setFlagStatusTef(null)
    setIsTefInProgress(false)
    CartController.clearbandeiraCartao()
    CartController.clearDigitalWalletName()
    authHash = ''
    return {
        error: true,
        errorType: 'concomitant tef transaction'
    }
}

const handleDllError = (retornoDllErro, routine) => {
    /* routine => transaction ou cofigure */
    setFlagStatusTef(null)
    let error = ''
    if (routine === 'transaction') {
        error = TefErrors.getErrorTransaction(retornoDllErro)
    } else if (routine === 'configure') {
        error = TefErrors.getErrorConfigure(retornoDllErro)
    } else {
        error = TEF_PROBLEM
    }
    if (retornoDllErro === -2 || retornoDllErro === -6) setAutoCancelTefTriggered(false)
    CartController.clearbandeiraCartao()
    CartController.clearDigitalWalletName()
    authHash = ''
    return {
        error: true,
        errorType: error
    }
}

const finalizaComEstornoAutomatico = async (date, hour, routineName, cupomFiscalSitef = '') => {
    // 0 = nao confirma transacao e estorna o valor
    await finishTransactionTEF(0, cupomFiscalSitef, date, hour)
    let message = `Transacao interrompida na rotina de ${routineName} com estorno do valor - PosCode: ${Util.getGeneralInfo()['posCode']}`
    Util.logComunication('Exception ', {}, message)
    CartController.clearbandeiraCartao()
    CartController.clearDigitalWalletName()
    authHash = ''
}

const cancelPayment = () => {
    MainTef.stopTransactionTef()
    digitalWalletSelected = ''
    setFlagStatusTef(null)
}

const checkPendingConfirmation = async function (transactionData) {
    Util.logComunication('checkPendingConfirmation', transactionData, {})
    if (transactionData && transactionData.date && transactionData.value) {
        await proceedToConfigureTef()
        let hasPendingConfitmation = await window.Android.getPendingConfirmation(transactionData.date, transactionData.text)
        Util.logComunication('checkPendingConfirmation', {date: transactionData.date, text: transactionData.text}, { hasPendingConfirmation: hasPendingConfitmation })
        return hasPendingConfitmation
    }
    return false
}

const finishIncompleteTransaction = async (transactionData) => {
    Util.logComunication('finishIncompleteTransaction', transactionData, {})
    let confirm = transactionData.finishTef
    if (transactionData && transactionData.date && transactionData.value) {
        setIsTefInProgress(false)
        let resultFinishTransactionTEF = await finishTransactionTEF(confirm, transactionData.text, transactionData.date, transactionData.time, transactionData.value)
        return resultFinishTransactionTEF
    }
}

const setFlagStatusTef = (data) => {
    if (!data) {
        setIsTefInProgress(false)
    }
    data = JSON.stringify(data)
    localStorage.setItem('flagStatusTef', data)
}

const getFlagStatusTef = () => {
    let data = localStorage.getItem('flagStatusTef')
    if (data) {
        return JSON.parse(data)
    }
    return null
}

const startTefTransire = async (value, type) => {
    let data = {
        amount: value,
        typeTransaction: type,
        creditType: 'NO_INSTALLMENT',
        installment: 1,
        isTyped: false,
        isPreAuth: false,
        interestType: 'MERCHANT',
        printReceipt: false,
        entityIdentifier: ''
    }
    await window.TransireIntegration.transaction(JSON.stringify(data))
}
const cancelTransactionTransire = async (nsu, entityIdentifier, nfceCode, saleCode) => {
    /*
        @type: string cancelTransaction
        @nsu: string Identificador interno da transação
        @entityIdentifier string Identificador do EC/PDV (opcional). Caso seja mandado em uma requisição, deve ser mandado igual nas outras.
        @nfceCode string Código do NFCE. Deve ser armazenado para acionar a finalização da transação.
    */
    dataCancelTransactionTransire.nfceCode = nfceCode
    dataCancelTransactionTransire.saleCode = saleCode
    const data = {
        type: 'cancelTransaction',
        nsu: nsu,
        entityIdentifier: entityIdentifier
    }
    await window.TransireIntegration.cancelTransaction(JSON.stringify(data))
}
const finishTefTransire = async (result) => {
    if (result && result.type === 'CANCELLATION' && result.result === true) {
        let resultCancelSale = await SaleController.cancelSale(dataCancelTransactionTransire.nfceCode, dataCancelTransactionTransire.saleCode)
        if (resultCancelSale && !resultCancelSale.error) {
            Util.showInfoModal(LocaleController.getString('venda_cancelada_com_sucesso') + (resultCancelSale.message ? resultCancelSale.message : ''), false)
        } else {
            Util.showInfoModal(LocaleController.getString('erro_ao_cancelar_venda') + (resultCancelSale.result && resultCancelSale.result.message ? resultCancelSale.result.message : ''), false)
        }
    }
    if (result && result.type === 'TRANSACTION') {
        eventModule.$emit('finishTefTransaction', result)
    }
}
const getMethodPaymentTransireType = (IDTIPORECE) => {
    if (IDTIPORECE === '1') {
        return 'CREDIT'
    } else if (IDTIPORECE === 'H') {
        return 'PIX'
    } else {
        return 'DEBIT'
    }
}
export default {

    getAutoCancelTefTriggered,
    startRechargeMode,
    stopRechargeMode,
    isInRechargeMode,
    finishTransactionTEF,
    startTefTransire,

    getPaymentMethods: function () {
        return paymentMethods
    },
    updatePaymentMethods: function () {
        paymentMethods = Util.getLocalConfigs('metodosPagamento')
    },
    navigateToCheckout: function (router) {
        router.push('checkout')
    },
    navigateToConsumer: function (router) {
        router.push('consumer')
    },

    setPaymentNumber: function (number) {
        paymentNumber = number
    },

    setHashCode: function (hashCodeNumber) {
        authHash = hashCodeNumber
    },

    getHashCode: function () {
        return authHash
    },

    setCancelTefData: function (nsu, date, value) {
        cancelTefData.nsu = nsu
        cancelTefData.date = date
        cancelTefData.value = value
    },

    setCollectDataModalData: function (data) {
        collectDataModalData = data
    },

    getCollectDataModalData: function () {
        return collectDataModalData
    },

    setCancelTefProof: function (text) {
        cancelTefData.proof = text
    },

    getCancelTefData: function () {
        return cancelTefData
    },

    clearCancelTefData: function () {
        cancelTefData.nsu = null
        cancelTefData.date = null
        cancelTefData.value = null
        cancelTefData.proof = null
    },

    getDigitalWallet: function () {
        return digitalWalletSelected
    },

    setDigitalWallet: function (walletCode) {
        digitalWalletSelected = walletCode
    },

    clearDigitalWallet: function () {
        digitalWalletSelected = ''
    },

    doPayment: async function (paymentMethod, orderCPF, router, rechargeValue, rechargeFamily) {
        let retornoDllErro = null
        let routine = ''
        if (paymentMethod.IDTIPORECE === '9' || paymentMethod.IDTIPORECE === 'A') {
            return await SaleController.performSale(paymentNumber, authHash, paymentMethod, orderCPF, router)
        } else if (paymentMethod.IDTIPORECE === '4') {
            // Se a forma de pagamento escolhida foi dinheiro, chama a performSale imediatamente
            return await SaleController.performSale(paymentNumber, authHash, paymentMethod, orderCPF, router)
        } else {
            let isRechargePayment = rechargeValue != null
            let date = moment().format('YYYYMMDD')
            let hour = moment().format('HHmmss')
            let cupomFiscalSitef = date + hour + moment().milliseconds()
            let startTime = moment()
            if (Util.isTransire()) {
                /* Quando for transire, a transação é iniciada pelo Android e o resultado é retornado pela função onTransactionResult */
                let value = CartController.getTotalPriceAsFloat()
                value = value * 100
                value = value.toFixed(0)
                dataTransire.paymentSelectedMethod = paymentMethod
                dataTransire.consumerCpf = orderCPF
                dataTransire.router = router
                dataTransire.date = date
                dataTransire.hour = hour
                dataTransire.paymentType = getMethodPaymentTransireType(paymentMethod.IDTIPORECE)
                await startTefTransire(value, dataTransire.paymentType)
            } else {
                let resConfig = await proceedToConfigureTef()
                if (!resConfig || (resConfig && resConfig.error)) {
                    retornoDllErro = (resConfig && (resConfig.result || resConfig.errorType)) || ''
                    routine = 'configure'
                    return handleDllError(retornoDllErro, routine)
                }
                if (resConfig && !resConfig.error) {
                    let tefSuccess = false
                    if (resConfig.result === 0) {
                        let tefFunctionCode = generateTefFunctionCode(paymentMethod.IDTIPORECE)
                        let totalValue = isRechargePayment ? rechargeValue : CartController.calculateTotalPrice()
                        totalValue = totalValue.replace('R$', '').trim()

                        let additionalParams = buildAdditionalParams(tefFunctionCode)
                        let resStart = await startTransactionTEF(tefFunctionCode, totalValue, cupomFiscalSitef, date, hour, 'operador', additionalParams)
                        let resultJson = null
                        try {
                            resultJson = JSON.parse(resStart.result)
                        } catch (error) {
                            resultJson = {
                                retornoDll: -10006,
                                error: true
                            }
                        }

                        if (resultJson.retornoDll === 10000) {
                            let isDigitalWalletPayment = tefFunctionCode === 122
                            let resContinua = await MainTef.continuaTransacaoTef(totalValue, null, null, null, null, null, null, false, null, isDigitalWalletPayment)
                            if (!resContinua.error && resContinua.finishedTransaction) {
                            // Tudo correu bem com o pagamento, mas a transação TEF só será finalizada dentro da rotina de
                            // venda. Se a venda através da Odhen Interface for concluída com sucesso, a transação TEF será
                            // confirmada. Se a venda falhar, a transação TEF será finalizada sem confirmação (gera
                            // restituição automática do valor pago)
                                tefSuccess = true
                                PaymentTimeoutController.clear()
                                let endTime = moment()
                                Util.logComunication('Tempo de execução do Pagamento: ' + endTime.diff(startTime, 'seconds') + ' segundos', null, null)
                                if (isRechargePayment) {
                                    return await IdentifiedConsumerController.doRechargePayment(paymentNumber, authHash, paymentMethod, orderCPF, date, hour, rechargeValue, rechargeFamily, cupomFiscalSitef)
                                } else {
                                    eventModule.$emit('setTefMessage', '')
                                    eventModule.$emit('hideLoadingTef', true)
                                    if (Util.isAndroidMode()) await Util.sleep(200)
                                    return await SaleController.performSale(paymentNumber, authHash, paymentMethod, orderCPF, router, date, hour, false, cupomFiscalSitef)
                                }
                            } else if (resContinua.retornoDll) {
                                retornoDllErro = resContinua.retornoDll
                                routine = 'transaction'
                            } else if (resContinua.error) {
                                retornoDllErro = resContinua.retornoDll || ''
                                routine = 'transaction'
                            }
                        } else if (resultJson.error) {
                            retornoDllErro = resultJson.retornoDll
                            routine = 'transaction'
                            Util.logComunication('Android Start TEF ', {}, resultJson)
                        }
                    } else {
                        retornoDllErro = resConfig.result
                        routine = 'configure'
                    }

                    let routineName = isRechargePayment ? 'recarga' : 'pagamento'
                    if (retornoDllErro > 0) {
                        await finalizaComEstornoAutomatico(date, hour, routineName, cupomFiscalSitef)
                    }
                    setFlagStatusTef(null)
                    if (!tefSuccess) {
                        let result = handleDllError(retornoDllErro, routine)
                        if (result && result.error) return result
                    } else {
                        CartController.clearCartAndNavigateHome(router)
                    }
                } else if (isTefInProgress) {
                    return handleTefInProgressError()
                }
            }
        }
    },

    doComplementaryPayment: async function (paymentMethod, orderCPF, router, excessValue) {
        let date = moment().format('YYYYMMDD')
        let hour = moment().format('HHmmss')
        let cupomFiscalSitef = date + hour + moment().milliseconds()
        let retornoDllErro = null
        let routine = ''
        let resConfig = await proceedToConfigureTef()

        if (resConfig) {
            let tefSuccess = false
            if (resConfig.result === 0) {
                let tefFunctionCode = generateTefFunctionCode(paymentMethod.IDTIPORECE)
                excessValue = Util.formatMoney(excessValue)
                excessValue = excessValue.replace('R$', '').trim()

                let additionalParams = buildAdditionalParams(tefFunctionCode)
                let resStart = await startTransactionTEF(tefFunctionCode, excessValue, cupomFiscalSitef, date, hour, 'operador', additionalParams)
                let resultJson = JSON.parse(resStart.result)

                if (resultJson.retornoDll === 10000) {
                    let isDigitalWalletPayment = tefFunctionCode === 122
                    let resContinua = await MainTef.continuaTransacaoTef(excessValue, null, null, null, null, null, null, false, null, isDigitalWalletPayment)
                    if (!resContinua.error && resContinua.finishedTransaction) {
                        // Tudo correu bem com o pagamento, mas a transação TEF só será finalizada dentro da rotina de
                        // venda. Se a venda através da Odhen Interface for concluída com sucesso, a transação TEF será
                        // confirmada. Se a venda falhar, a transação TEF será finalizada sem confirmação (gera
                        // restituição automática do valor pago)
                        tefSuccess = true
                        return {
                            error: false,
                            date: date,
                            hour: hour,
                            paymentNumber: paymentNumber,
                            authHash: authHash,
                            cupomFiscalSitef: cupomFiscalSitef
                        }
                    } else if (resContinua.retornoDll) {
                        retornoDllErro = resContinua.retornoDll
                        routine = 'transaction'
                    }
                }
            } else {
                retornoDllErro = resConfig.result
                routine = 'configure'
            }
            if (retornoDllErro > 0) {
                await finalizaComEstornoAutomatico(date, hour, 'pagamento complementar', cupomFiscalSitef)
            }
            setFlagStatusTef(null)
            if (!tefSuccess) {
                let result = handleDllError(retornoDllErro, routine)
                if (result && result.error) return result
            }
        } else if (isTefInProgress) {
            return handleTefInProgressError()
        } else {
            return handleTefError()
        }
    },

    doPrincipalPayment: async function (paymentMethod, orderCPF, router) {
        // performSale é chamada diretamente porque apenas pagamentos de crédito pessoal/débito consumidor chegam nesta função
        let emptyPaymentNumber = ''
        let emptyAuthHash = ''
        let date = ''
        let hour = ''
        let complementedPayment = true
        return await SaleController.performSale(emptyPaymentNumber, emptyAuthHash, paymentMethod, orderCPF, router, date, hour, complementedPayment)
    },

    cancelTef: async function (nsu, tefDate, value, saleType, nfceCode) {
        this.setCancelTefData(nsu, tefDate, value)
        const cancelTefFunctionCode = 200
        let date = moment().format('YYYYMMDD')
        let hour = moment().format('HHmmss')
        let cupomFiscalSitef = date + hour

        let resConfig = await proceedToConfigureTef()

        if (resConfig && !resConfig.error) {
            let tefSuccess = false
            let retornoDllErro = null
            let routine = ''
            if (resConfig.result === 0) {
                let totalValue = ''
                let additionalParams = ''

                let resStart = await startTransactionTEF(cancelTefFunctionCode, totalValue, cupomFiscalSitef, date, hour, 'operador', additionalParams)
                let resultJson = JSON.parse(resStart.result)

                if (resultJson.retornoDll === 10000) {
                    let resContinua = await MainTef.continuaTransacaoTef(totalValue, null, null, null, null, null, null, true, saleType)
                    if (!resContinua.error && resContinua.finishedTransaction) {
                        tefSuccess = true
                        let cancelSaleResponse = await this.cancelSale(nfceCode, cancelTefData.proof)

                        if (cancelSaleResponse) {
                            // 1 = confirma transacao
                            let resultFinishTransactionTEF = await finishTransactionTEF(1, cupomFiscalSitef, date, hour)
                            if (resultFinishTransactionTEF) {
                                Util.showInfoModal(LocaleController.getString('cancelamento_TEF_finalizado_sucesso'))
                            }
                            setFlagStatusTef(null)
                            this.clearCancelTefData()
                            return true
                        } else if (cancelSaleResponse && cancelSaleResponse.error) {
                            Util.showInfoModal(cancelSaleResponse.message)
                        }

                        this.clearCancelTefData()
                    } else if (resContinua.retornoDll) {
                        retornoDllErro = resContinua.retornoDll
                        routine = 'transaction'
                    }
                }
            } else {
                retornoDllErro = resConfig.result
                routine = 'configure'
            }

            // 0 = nao confirma transacao
            await finishTransactionTEF(0, cupomFiscalSitef, date, hour)
            setFlagStatusTef(null)
            this.clearCancelTefData()
            if (!tefSuccess) {
                if (retornoDllErro && retornoDllErro !== 10000) {
                    let result = handleDllError(retornoDllErro, routine)
                    if (result && result.error) {
                        Util.showInfoModal(result.errorType)
                        return result
                    }
                } /* else if (retornoDllErro === -43) {
                    Util.showInfoModal(PINPAD_ROUTINES_PROBLEM)
                } */
            }
        } else if (isTefInProgress) {
            return handleTefInProgressError()
        } else {
            return handleTefError(resConfig)
        }
    },
    funcoesAdministrativas: async function () {
        const tefFunctionCode = 110
        funcoesAdministrativasSelected = ''
        let resConfig = await proceedToConfigureTef()
        const date = moment().format('YYYYMMDD')
        const hour = moment().format('HHmmss')
        const cupomFiscalSitef = date + hour
        const totalValue = '0'

        if (resConfig && !resConfig.error) {
            let tefSuccess = false
            let retornoDllErro = null
            let routine = ''
            if (resConfig.result === 0) {
                let additionalParams = ''

                let resStart = await startTransactionTEF(tefFunctionCode, totalValue, cupomFiscalSitef, date, hour, 'operador', additionalParams)
                let resultJson = JSON.parse(resStart.result)

                if (resultJson.retornoDll === 10000) {
                    let resContinua = await MainTef.continuaTransacaoTef(null, null, null, null, null, null, null, false, null, false, true)
                    if (!resContinua.error && resContinua.finishedTransaction) {
                        tefSuccess = true
                    } else if (resContinua.retornoDll) {
                        retornoDllErro = resContinua.retornoDll
                        routine = 'transaction'
                    }
                }
            } else {
                retornoDllErro = resConfig.result
                routine = 'configure'
            }

            // 0 = nao confirma transacao
            // await finishTransactionTEF(0, null, null, null)
            /* this.clearCancelTefData() */
            this.setFuncoesAdministrativasSelected('')
            await finishTransactionTEF(1, '', '', '')
            if (!tefSuccess) {
                if (retornoDllErro && retornoDllErro !== 10000) {
                    let result = handleDllError(retornoDllErro, routine)
                    if (result && result.error) {
                        Util.showInfoModal(result.errorType)
                        return result
                    }
                }
            }
        } else if (isTefInProgress) {
            this.setFuncoesAdministrativasSelected('')
            return handleTefInProgressError()
        } else {
            this.setFuncoesAdministrativasSelected('')
            return handleTefError(resConfig)
        }
    },
    reprintTef: async function (nsu, tefDate, value) {
        const tefFunctionCode = 113
        this.setCancelTefData(nsu, tefDate, value)
        const date = moment().format('YYYYMMDD')
        const hour = moment().format('HHmmss')
        const cupomFiscalSitef = date + hour
        const totalValue = value
        let resConfig = await proceedToConfigureTef()

        if (resConfig && !resConfig.error) {
            let tefSuccess = false
            let retornoDllErro = null
            let routine = ''
            if (resConfig.result === 0) {
                let additionalParams = ''
                let resStart = await startTransactionTEF(tefFunctionCode, totalValue, cupomFiscalSitef, date, hour, 'operador', additionalParams)
                let resultJson = JSON.parse(resStart.result)

                if (resultJson.retornoDll === 10000) {
                    let resContinua = await MainTef.continuaTransacaoTef(null, null, null, null, null, null, null, false, null, false, true)
                    if (!resContinua.error && resContinua.finishedTransaction) {
                        tefSuccess = true
                    } else if (resContinua.retornoDll) {
                        retornoDllErro = resContinua.retornoDll
                        routine = 'transaction'
                    }
                }
            } else {
                retornoDllErro = resConfig.result
                routine = 'configure'
            }

            this.setFuncoesAdministrativasSelected('')
            await finishTransactionTEF(1, '', '', '')
            if (!tefSuccess) {
                if (retornoDllErro && retornoDllErro !== 10000) {
                    let result = handleDllError(retornoDllErro, routine)
                    if (result && result.error) {
                        Util.showInfoModal(result.errorType)
                        return result
                    }
                }
            }
        } else if (isTefInProgress) {
            this.setFuncoesAdministrativasSelected('')
            return handleTefInProgressError()
        } else {
            this.setFuncoesAdministrativasSelected('')
            return handleTefError(resConfig)
        }
    },
    getIsTefInProgress,
    cancelSale: async function (nfceCode, cancelTefData = null) {
        let cancelSaleResponse = await SaleController.cancelSale(nfceCode)
        if (cancelSaleResponse && !cancelSaleResponse.error) {
            let dadosImpressao = cancelSaleResponse.data && cancelSaleResponse.data.cancel &&
                            cancelSaleResponse.data.cancel.dadosImpressao

            let cabecalho = (dadosImpressao && dadosImpressao.TEXTOCUPOM) || ''
            let chaveAcesso = (dadosImpressao && dadosImpressao.TEXTOCODIGOBARRAS) || null
            let QRCODE = (dadosImpressao && dadosImpressao.TEXTOQRCODE) || null
            let RODAPE = (dadosImpressao && dadosImpressao.TEXTORODAPE) || null

            if (cancelTefData) {
                await PrinterController.printCancel(cancelTefData, cancelSaleResponse, nfceCode)
            }

            if (cabecalho) {
                await PrinterController.printCancelFiscal(cabecalho, chaveAcesso, QRCODE, RODAPE)
            } else {
                Util.showInfoModal('Não foram recebidos dados para impressão do cancelamento')
            }

            this.clearCancelTefData()
            if (cancelSaleResponse.data && cancelSaleResponse.data.cancel && cancelSaleResponse.data.cancel.mensagemNfce) {
                Util.showInfoModal(cancelSaleResponse.data.cancel.mensagemNfce)
            }
            return true
        } else if (cancelSaleResponse && cancelSaleResponse.error) {
            Util.showInfoModal(cancelSaleResponse.message)
            return false
        }
    },
    cancelPayment,
    setComprovanteTef: function (comprovante) {
        comprovanteTef = comprovante
    },
    getComprovanteTef: function () {
        return comprovanteTef
    },
    getFuncoesAdministrativasSelected,
    setFuncoesAdministrativasSelected,
    printComprovanteTef: async function (comprovanteTef) {
        return await PrinterController.simplePrint(comprovanteTef)
    },
    setWaitingForData,
    getWaitingForData,
    getFlagStatusTef,
    setFlagStatusTef,
    getDataTransire: function () {
        return dataTransire
    },
    cancelTransactionTransire,
    finishTefTransire,
    checkPendingConfirmation,
    finishIncompleteTransaction
}



// WEBPACK FOOTER //
// ./src/assets/controllers/PaymentController.js